import APIRequest from '../api/APIRequest';

export const noticeService = {
  // Get all notices based on user role (handled by backend)
  getNotices: async (token) => {
    try {
      const api = new APIRequest();
      const response = await api.request('/notice', 'GET', {}, token);
      if (response && response.success) {
        return response.notices;
      } else {
        return [];
      }
    } catch (error) {
      console.error('Error fetching notices:', error);
      return [];
    }
  },

  // Create new notice
  createNotice: async (noticeData, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request('/notice', 'POST', noticeData, token);
      return response;
    } catch (error) {
      console.error('Error creating notice:', error);
      return { success: false, message: 'Failed to create notice' };
    }
  },

  // Acknowledge notice
  acknowledgeNotice: async (id, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/notice/${id}/acknowledge`, 'POST', {}, token);
      return response;
    } catch (error) {
      console.error('Error acknowledging notice:', error);
      return { success: false, message: 'Failed to acknowledge notice' };
    }
  },

  // Get sent notices analytics for staff/admin
  getSentNoticesAnalytics: async (token) => {
    try {
      const api = new APIRequest();
      const response = await api.request('/notice/sent/analytics', 'GET', {}, token);
      if (response && response.success) {
         return response.notices;
      }
      return [];
    } catch (error) {
       console.error('Error fetching sent notices analytics:', error);
       return [];
    }
  },
  
  // Delete notice
  deleteNotice: async (id, token) => {
    try {
       const api = new APIRequest();
       const response = await api.request(`/notice/${id}`, 'DELETE', {}, token);
       return response;
    } catch (error) {
       console.error('Error deleting notice:', error);
       return { success: false };
    }
  }
};
